$(document).on 'turbo:load', ->
  new ytPlayerWithGaTracking()

class ytPlayerWithGaTracking
  constructor: ->
    @debug = true
    @bindElements()
    @setupYoutubePlayer()

  bindElements: ->
    $(document).on 'click', '[data-track-on="click"]', (e) =>
      toTrack = $(e.currentTarget)
      if !toTrack.hasClass('tracked')
        @trackNewEvent(
          toTrack.data('track-category'),
          toTrack.data('track-action'),
          toTrack.data('track-label')
        )
        toTrack.addClass('tracked') if toTrack.data('track-once') == true

    $(document).on 'change', '[type="checkbox"][data-track-on="change"]', (e) =>
      toTrack = $(e.currentTarget)
      checked = if toTrack.prop('checked') then 'true' else 'false'
      if !toTrack.hasClass('tracked')
        @trackNewEvent(
          toTrack.data('track-category'),
          toTrack.data("track-action-#{checked}"),
          toTrack.data('track-label')
        )
        toTrack.addClass('tracked') if toTrack.data('track-once') == true

    $(document).on 'focus', '[data-track-on="focus"]', (e) =>
      toTrack = $(e.currentTarget)
      if !toTrack.hasClass('tracked')
        @trackNewEvent(
          toTrack.data('track-category'),
          toTrack.data('track-action'),
          toTrack.data('track-label')
        )
        toTrack.addClass('tracked') if toTrack.data('track-once') == true

    $(document).on 'keyup', '[data-track-on="keyup"]', (e) =>
      toTrack = $(e.currentTarget)
      if !toTrack.hasClass('tracked')
        @trackNewEvent(
          toTrack.data('track-category'),
          toTrack.data('track-action'),
          toTrack.data('track-label')
        )
        toTrack.addClass('tracked') if toTrack.data('track-once') == true

    $(document).on 'submit', '[data-track-on="submit"]', (e) =>
      toTrack = $(e.currentTarget)
      if !toTrack.hasClass('tracked')
        @trackNewEvent(
          toTrack.data('track-category'),
          toTrack.data('track-action'),
          toTrack.data('track-label')
        )
        toTrack.addClass('tracked') if toTrack.data('track-once') == true

    # Trigger track Dig Deeper inner links
    $(document).on 'click', '.more_text a', (e) =>
      toTrack = $(e.currentTarget)
      $('.dig-deeper-link-trigger').data('track-action', 'outbound click - ' + toTrack.attr('href'))
      $('.dig-deeper-link-trigger').click()

    $('body').on 'translatePage', (jqEvent) =>
      { originalEvent: e } = jqEvent
      lang = e? && e.detail? && e.detail.lang

      return if !lang

      @player.destroy()
      @loadPlayer({
        cc_lang_pref: lang,
        cc_load_policy: 1
      })


  trackNewEvent: (category, action, label) ->
    label = "" if label == undefined
    if @inDebugMode()
      console.log "ga('send', 'event', '" + category + "', '" + action + "', '" + label + "')"
    ga('send', 'event', category, action, label)


  setupYoutubePlayer: ->
    if YT?.Player?
      @loadPlayer()
    else
      window.onYouTubeIframeAPIReady = =>
        @loadPlayer()

      hostUrl = 'https://www.youtube.com/iframe_api'

      tag = document.createElement('script')
      tag.src = hostUrl
      firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

  loadPlayer: (playerVars = {}) ->
    data = $("#playerContainer").data()
    if data?
      lessonId = data.lessonId
      videoId = data.videoId
      @timelineMarker = 0
      @videoPlaybackQuality = "medium"

      playerDefaultVars =
        rel: 0
        modestbranding: 1
        wmode: "transparent"
        start: data.videoStart
        end: data.videoEnd

      player = new YT.Player("playerContainer",
        height: '360',
        width: '640',
        playerVars: $.extend({}, playerDefaultVars, playerVars),
        videoId: videoId
        events:
          onReady: (event) ->
            new App.Components.YoutubeVideoSeekTo(
              player: event.target, selector: '[data-seek-to]'
            )

          # we can get current time with player.getCurrentTime()
          onStateChange: (event) =>
            lessonsAll = new App.lessonsAll()
            switch event.data
              when YT.PlayerState.PLAYING
                $(document).trigger 'VideoPlayer::started', event.target

                @checkTimeline(true, event, videoId, lessonId)
                @trackNewEvent("video", "initiate", "#{videoId}|#{lessonId}")
                lessonsAll.logView()
              when YT.PlayerState.PAUSED
                @checkTimeline(false, event)
                $(document).trigger 'VideoPlayer::paused', event.target
              when YT.PlayerState.ENDED
                unless $(".lessonsShowView").length is 0
                  lessonsAll.nextPanel(null, "videoState")
                $(document).trigger 'VideoPlayer::ended', event.target
                lessonsAll.logEnded()
      )
      $('#playerContainer').parent().fitVids()

      @player = player

  checkTimeline: (flag, event, videoId, lessonId) ->
    self = @
    if flag is true
      @timer = setInterval ->
        self.getPlayerPercentageViewed(event, videoId, lessonId)
      , 1200
    else
      clearInterval(@timer)

  getPlayerPercentageViewed: (event, videoId, lessonId) =>
    currentTime = event.target.getCurrentTime()
    videoDuration = event.target.getDuration()
    currentViewedPercentage = Math.round(currentTime / videoDuration * 100)
    currentVideoPlaybackQuality = event.target.getPlaybackQuality()

    # Trigger tracking if video playback enters or exits fullscreen mode
    if @videoPlaybackQuality != currentVideoPlaybackQuality
      @trackNewEvent(
        "video",
        "fullscreen",
        (if currentVideoPlaybackQuality == "medium" then "exit" else "enter")
      )
      @videoPlaybackQuality = currentVideoPlaybackQuality

    # Trigger tracking at specific points in timeline
    if _.contains([50, 75], currentViewedPercentage)
      if @timelineMarker != currentViewedPercentage
        @trackNewEvent(
          "video", "#{currentViewedPercentage}%", "#{videoId}|#{lessonId}"
        )
      @timelineMarker = currentViewedPercentage
      clearInterval(@timer) if @timelineMarker == 100

  # Convenience method
  inDebugMode: ->
    @debug is true
